import styled from 'styled-components';

export const FileSelector = styled.input`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
  cursor: pointer;
`;

export const FileLabel = styled.label`
  font-size: 1em;
  font-weight: 700;
  color: #2f9d6d;
  background-color: #FFFFFF;
  border: 2.5px solid #2f9d6d;
  display: inline-block;
  cursor: pointer;
  padding: 15px;
  margin: 10px;
  border-radius: 25px;
  width: 300px;
  text-align: center;
`;

export const LogoView = styled.img`
  width: 100px;
`;

export const flexStyles = {
  flexDirection: 'column',
  justifyContent: 'space-around',
  backgroundSize: 'auto auto',
  backgroundColor: '#EFEFEF',
  borderRadius: '20px',
  alignItems: 'center',
  height: '100%',
  margin: '20px'
};

export const BannerImage = styled.img`
  height: 100px;
  max-width: 90%;
`;

export const BannerTitle = styled.div`
  font-weight: bold;
  font-size: 24px;
`;

export const BannerLinkLabel = styled.span`
  font-weight: bold;
`;

export const BannerLink = styled.a`
  text-decoration: none;
  word-break: break-word;
  cursor: pointer;
  color: blue;
  margin-left: 10px;
`;

export const BannerButton = styled.span`
  font-weight: bold;
  cursor: pointer;
`;

export const BannerButtonDelete = styled(BannerButton)`
  color: red;
`;
